// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__T67cF","preTitle":"Hero_preTitle__kysQ2","title":"Hero_title__Wg0PZ","text":"Hero_text___MoGY","button":"Hero_button__mAPBe"};